/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function Breadcrumbs({ icon, title, route, light }) {
	const routes = route.slice(0, -1);

	return (
		<SoftBox mr={{ xs: 0, xl: 8 }}>
			<MuiBreadcrumbs
				sx={{
					"& .MuiBreadcrumbs-separator": {
						color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
					},
				}}
			>
				<Link to="/">
					<SoftTypography
						component="span"
						variant="body2"
						color={light ? "white" : "dark"}
						opacity={light ? 0.8 : 0.5}
						sx={{ lineHeight: 0,fontSize:32 }}
					>
						<Icon>{icon}</Icon>
					</SoftTypography>
				</Link>
				{routes.filter(part => isNaN(part)).map(el => (
					<Link to={`/${el}`} key={el}>
						<SoftTypography
							component="span"
							variant="button"
							fontWeight="regular"
							textTransform="capitalize"
							color={light ? "white" : "dark"}
							opacity={light ? 0.8 : 0.5}
							sx={{ lineHeight: 0 }}
						>
							{el.replaceAll("-", " ")}
						</SoftTypography>
					</Link>
				))}
				{routes.length === 0 && (
					<SoftTypography
						variant="button"
						fontWeight="regular"
						textTransform="capitalize"
						color={light ? "white" : "dark"}
						sx={{ lineHeight: 0,fontSize:14 }}
					>
						Dashboard
					</SoftTypography>
				)}
			</MuiBreadcrumbs>
			<SoftTypography
				fontWeight="bold"
				textTransform="capitalize"
				variant="h2"
				color={light ? "white" : "dark"}
				noWrap
				mt={1}
			>
				{title.replaceAll("-", " ")}
			</SoftTypography>
		</SoftBox>
	);
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
	light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
	icon: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
	route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	light: PropTypes.bool,
};

export default Breadcrumbs;
